import CustomAddRemoveItemsModal from "../../../../components/AddRemoveItemsModal/CustomAddRemoveItemsModal";
import {ManageEmployeeDepartmentApp} from "../Funtionallity/ManageEmployeeDepartmentApp";
import {TABLES} from "../../../../Apis/Tables";
import {userListToLabelEmailPhoneValue} from "../../../../Apis/functions";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const ManageEmployeeDepartment = ({show, onHide, selectedId, setModified, modified }) => {
    const { handleDelete, handleAdd, selectedEmployee } = ManageEmployeeDepartmentApp({
        onHide,
        selectedId,
        setModified,
        modified
    });

    return (
        <CustomAddRemoveItemsModal
            show={show}
            onHide={onHide}
            selected={selectedEmployee}
            handleDelete={handleDelete}
            handleAdd={handleAdd}
            option={TABLES.USER_NOT_ASSIGNED_TO_DEPARTMENT}
            modelId={selectedId}
            listTransform={userListToLabelEmailPhoneValue}
        />
    );
};

export default ManageEmployeeDepartment;
